module.exports = __webpack_public_path__ + "static/media/iPhone14_1.dfd0d4b0.png";